import { fetch } from '../request'
import type {
  IPageResponse,
  IResponse,
  BrandItem,
  BrandParams,
  UpdateBrand,
  UpdateBrandStatusRequest,
  ListParams,
  ChangeBrandParams,
  Following,
  ToFollow,
  FollowTeam,
} from '~/api/interface'

// 列表
export const getBrandList = (params?: BrandParams & ListParams) => {
  return fetch<IPageResponse<BrandItem>>('/brand/', {
    method: 'GET',
    params,
  })
}

// Modal列表
export const getModalList = (params?: BrandParams) => {
  return fetch<IResponse<BrandItem[]>>('/youyan/team_space/', {
    method: 'GET',
    params,
  })
}

// 更新品牌跟随状态（同意或拒绝）
export const updateBrandStatus = (data: UpdateBrandStatusRequest) =>
  fetch('/brand/brand_following/update_brand_msg/', {
    method: 'PUT',
    body: data,
  })

// 批量取消、增加品牌规范
export const changeBrandStatus = (body: ChangeBrandParams) => {
  return fetch<IResponse<BrandItem[]>>('/brand/change_brand_status/', {
    method: 'PUT',
    body,
  })
}

// 更新
export const updateBrand = (body: UpdateBrand) => {
  return fetch<IResponse>('/brand/', {
    method: 'PUT',
    body,
  })
}

// 品牌跟随信息
export const getFollowing = () => {
  return fetch<IResponse<Following[]>>('/brand/brand_following/', {
    method: 'GET',
  })
}

// 发送品牌跟随消息
export const sendFollow = (body: ToFollow) => {
  return fetch<IResponse>('/brand/brand_following/send_following_msg/', {
    method: 'POST',
    body,
  })
}

// 解除跟随
export const secureFollow = () => {
  return fetch<IResponse>('/brand/brand_following/delete_following/', {
    method: 'DELETE',
  })
}

// 品牌跟随团队列表
export const getFollwTeam = () => {
  return fetch<IResponse<FollowTeam[]>>('/user/identify/friend_teams/', {
    method: 'GET',
  })
}
